(function () {
  'use strict';

  var accessKey = 'sr_review_access_v2';
  var legacySessionKey = 'sr_review_access_v1';
  var accessTtlMs = 7 * 24 * 60 * 60 * 1000;
  var expectedHash = 'afccd937e6ac2d1b6d6e9f318bc5e8a179c977c7413b33b3e4d902ff8cec501e';

  function addNoIndex() {
    var robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement('meta');
      robots.name = 'robots';
      document.head.appendChild(robots);
    }
    robots.content = 'noindex,nofollow,noarchive,nosnippet';
  }

  function rememberAccess() {
    var grant = JSON.stringify({
      granted: true,
      expiresAt: Date.now() + accessTtlMs
    });

    try {
      window.localStorage.setItem(accessKey, grant);
      return;
    } catch (error) {}

    try {
      window.sessionStorage.setItem(accessKey, grant);
    } catch (error) {}
  }

  function hasStoredAccess() {
    var stored = null;

    try {
      stored = window.localStorage.getItem(accessKey);
    } catch (error) {}

    if (!stored) {
      try {
        stored = window.sessionStorage.getItem(accessKey);
      } catch (error) {}
    }

    if (stored) {
      try {
        var grant = JSON.parse(stored);
        if (grant.granted === true && Number(grant.expiresAt) > Date.now()) return true;
      } catch (error) {}

      try {
        window.localStorage.removeItem(accessKey);
        window.sessionStorage.removeItem(accessKey);
      } catch (error) {}
    }

    try {
      if (window.sessionStorage.getItem(legacySessionKey) === 'granted') {
        rememberAccess();
        return true;
      }
    } catch (error) {}

    return false;
  }

  function unlock(shouldRemember) {
    var content = document.querySelector('[data-sr-review-content]');
    if (!content) return;
    content.hidden = false;
    content.removeAttribute('inert');
    content.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('sr-review-unlocked');
    if (shouldRemember) rememberAccess();
  }

  addNoIndex();

  if (hasStoredAccess()) unlock(false);

  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('sr-review-form');
    var input = document.getElementById('sr-review-password');
    var error = document.getElementById('sr-review-error');
    if (!form || !input || !error) return;
    if (document.documentElement.classList.contains('sr-review-unlocked')) return;

    window.setTimeout(function () {
      input.focus();
    }, 50);

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      error.textContent = '';

      try {
        var bytes = new TextEncoder().encode(input.value);
        var digest = await window.crypto.subtle.digest('SHA-256', bytes);
        var actualHash = Array.from(new Uint8Array(digest))
          .map(function (value) {
            return value.toString(16).padStart(2, '0');
          })
          .join('');
        if (actualHash === expectedHash) {
          unlock(true);
          return;
        }
      } catch (hashError) {}

      input.value = '';
      input.focus();
      error.textContent = 'That password is not correct. Please try again.';
    });
  });
})();
